import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Text from 'shopper/components/Text';

import FollowUserButton from 'components/FollowUserButton';
import UserAvatar from 'components/UserAvatar';

const UserFollowsListItem = ({
  className,
  gaEventCategory,
  userId,
  userLevel,
  userPhoto,
  userName,
  userUsername,
  userTypeName,
  ...rest
}) => (
  <div
    className={twMerge(
      'flex border-b border-neutral-high-200 py-2 dark:border-neutral-low-300',
      className
    )}
    {...rest}
  >
    <UserAvatar
      size="size4"
      userId={userId}
      userLevel={userLevel}
      userName={userName}
      userPhoto={userPhoto}
      userTypeName={userTypeName}
      userUsername={userUsername}
      asLink
    />
    <div className="ml-4 flex w-full items-center">
      <div className="flex w-full flex-col items-start">
        <Text className="mr-2 line-clamp-1 max-w-[120px]" bold>
          {userName}
        </Text>
      </div>
    </div>
    <div className="flex items-center">
      <FollowUserButton gaEventCategory={gaEventCategory} userId={userId} />
    </div>
  </div>
);

UserFollowsListItem.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  userLevel: PropTypes.number.isRequired,
  userPhoto: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  userTypeName: PropTypes.string.isRequired,
};

export default UserFollowsListItem;
